@if (recordFormSetId(); as recordFormSetId) {
    <p-dialog
        header="{{ ('folder.forms.recordForm.' + (this.recordFormDataCopy() || !this.recordFormData()? 'createHeader' : 'editHeader') | translate) + ' ' + recordFormSetType() }}"
        [(visible)]="recordFormModalVisible"
        [modal]="true"
        [maximizable]="true"
        [draggable]="true"
        [resizable]="true"
        (onHide)="closeRecordForm()"
    >
        @switch (recordFormSetType()) {
            @case (FormSetEnum.ESAS) {
                <app-form-esas-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-esas-form>
            }
            @case (FormSetEnum.MSSE) {
                <app-form-msse-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-msse-form>
            }
            @case (FormSetEnum.IADL) {
                <app-form-iadl-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-iadl-form>
            }
            @case (FormSetEnum.DEKN) {
                <app-form-dekn-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-dekn-form>
            }
            @case (FormSetEnum.PPS) {
                <app-form-pps-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-pps-form>
            }
            @case (FormSetEnum.OPZ) {
                <app-form-opz-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-opz-form>
            }
            @case (FormSetEnum.BI) {
                <app-form-bi-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-bi-form>
            }
            @case (FormSetEnum.NI) {
                <app-form-ni-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-ni-form>
            }
            @case (FormSetEnum.RVD) {
                <app-form-rvd-form
                    [folderFormId]="recordFormSetId"
                    [folderFormData]="recordFormData()"
                    [copy]="recordFormDataCopy()"
                    (submitForm)="submitFormData($event)"
                    (closeForm)="closeRecordForm()"
                ></app-form-rvd-form>
            }
        }
    </p-dialog>
}
